import React from "react";
import { formatBRL } from "../../../helpers/currency.helper";
import { Wrapper, Bar, CountBadge, Label, Total } from "./styles";

interface BottomCartBarProps {
  count: number;
  total: number;
  onClick: () => void;
}

export default function BottomCartBar({ count, total, onClick }: BottomCartBarProps) {
  if (count <= 0) return null;

  return (
    <Wrapper>
      <Bar type="button" onClick={onClick} aria-label="Ver carrinho">
        {/* key={count} remonta o badge a cada mudança para replay do "pop" */}
        <CountBadge key={count}>{count}</CountBadge>
        <Label>Ver carrinho</Label>
        <Total>{formatBRL(total)}</Total>
      </Bar>
    </Wrapper>
  );
}
